// Unimplemented on web
export default {} as Partial<{
  isAvailableAsync: () => Promise<boolean>;
  requestReview: () => Promise<void>;
}>;
